import React, { forwardRef, useImperativeHandle, useState } from 'react'

import { DisciplinaTurmaCertificacao } from 'src/tipos'

import {
  ModalBase,
  Botao,
  ModalBaseProps,
  SubTitulo,
  IconeDecisao
} from '../../../../../../../src/componentes'
import { ContainerBotoes, ContainerModal, CorpoModal } from '../../styles'
import { ModalIncluirDisciplinaCertificacaoRef } from '../modal-incluir-disciplina/tipos'

const ModalDesvincularDisciplina: React.ForwardRefRenderFunction<
  ModalIncluirDisciplinaCertificacaoRef,
  ModalBaseProps
> = ({ backdrop, acaoPrimaria, acaoSecundaria }, ref) => {
  const [aberta, definirAberta] = useState(false)
  const [indexDisciplina, definirIndexDisciplina] = useState(null)
  const [disciplina, definirDisciplina] = useState<DisciplinaTurmaCertificacao>(
    null
  )

  const fechar = () => {
    definirIndexDisciplina(null)
    definirDisciplina(null)
    definirAberta(false)
  }

  const abrir = (
    disciplina?: DisciplinaTurmaCertificacao,
    indexDisciplina?: number
  ) => {
    definirIndexDisciplina(indexDisciplina)
    definirDisciplina(disciplina)
    definirAberta(true)
  }

  useImperativeHandle<
    ModalIncluirDisciplinaCertificacaoRef,
    ModalIncluirDisciplinaCertificacaoRef
  >(ref, () => ({
    fechar,
    abrir
  }))

  return (
    <ModalBase
      id="modal-confirmacao-cancelamento"
      aberta={aberta}
      backdrop={backdrop}
    >
      <CorpoModal>
        <ContainerModal>
          {IconeDecisao}
          <h5> Deseja realmente excluir esta disciplina da turma? </h5>
          <SubTitulo texto="Selecione uma opção" />
          <ContainerBotoes>
            <Botao
              type="button"
              id="btn-cancelar"
              texto="Não"
              tema="Secundario"
              onClick={() => {
                acaoSecundaria && acaoSecundaria()
                fechar()
              }}
            />
            <Botao
              type="button"
              id="btn-salvar"
              texto="Sim"
              onClick={() => {
                acaoPrimaria({ disciplina, indexDisciplina })
                fechar()
              }}
            />
          </ContainerBotoes>
        </ContainerModal>
      </CorpoModal>
    </ModalBase>
  )
}

export const ModalExcluirDisciplina = forwardRef(ModalDesvincularDisciplina)
